export default __webpack_public_path__ + "static/chemistry-min-416e650cb55b9fb9ebbb21a3eb4c75bf.png";